import { CircularProgress, Container, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, InputAdornment, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import api from "../../../../../Apis";
import GoBack from "../../../../Globals/GoBack";
import GroupFanpageItem from "./GroupFanpageItem";
import { useTranslation } from "react-i18next";
import SearchIcon from '@mui/icons-material/Search'; // Nhớ import icon search

export default function GroupFanpage() {
    const { t, i18n } = useTranslation();
    const [cookies, setCookie] = useCookies('is_login');
    const [searchTerm, setSearchTerm] = useState(""); // 1. State cho ô search
    const [state, setState] = useState({
        group_fanpages: [],
        is_loading: true,
        error_message: ""
    })

    useEffect(() => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.is_login
            }
        };
        fetch(api.group_fanpage + `?lang=${i18n.language}`, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    setState({
                        ...state,
                        group_fanpages: result.data,
                        is_loading: false,
                        error_message: ""
                    })
                } else {
                    setState({
                        ...state,
                        group_fanpages: [],
                        is_loading: false,
                        error_message: result.message
                    })
                }
            } 
        )
    }, []);

    const updateGroupAfterDelete = (index) => {
        const group_fanpage_copy = [...state.group_fanpages];
        group_fanpage_copy.splice(index, 1);
        setState({...state, group_fanpages: group_fanpage_copy})
    }

    // 2. Logic lọc danh sách theo tên nhóm
    const filteredGroups = state.group_fanpages.filter((group) => 
        group.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Container maxWidth="xl">
            {/* <GoBack/> */}
            
            {/* 3. Ô Search */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={8}>
                    <Typography variant="h6" gutterBottom>
                        {t("post.pageGroupList")}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        placeholder={t("Tìm kiếm tên nhóm...")}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
            </Grid>

            <Grid item xs={12} md={12}>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>{t("groupFanpage.table.no")}</TableCell>
                                <TableCell>{t("groupFanpage.table.groupName")}</TableCell>
                                <TableCell>{t("common.detail")}</TableCell>
                                <TableCell>{t("groupFanpage.table.action")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                state.is_loading
                                ?
                                <TableRow>
                                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                        <CircularProgress />
                                    </TableCell>
                                </TableRow>
                                :
                                // 4. Map trên danh sách đã lọc (filteredGroups)
                                filteredGroups.length > 0 ? (
                                    filteredGroups.map((groupItem, index) => {
                                        return (
                                            <GroupFanpageItem
                                                key={index} // Nên có key cho map
                                                stt = { index + 1 }
                                                index_group = { index }
                                                updateGroupAfterDelete = { updateGroupAfterDelete }
                                                data = { groupItem }
                                                cookie = { cookies.is_login }
                                                total_fanpage = { groupItem.fanpages.length }
                                                fanpages = { groupItem.fanpages }
                                            />
                                        )
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            {t("Không tìm thấy nhóm nào")}
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Container>
    )
}